@file:OptIn(InternalResourceApi::class)

package yendo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/yendo.shared.generated.resources/"

@delegate:ResourceContentHash(528_724_194)
internal val Res.font.NotoEmoji: FontResource by lazy {
      FontResource("font:NotoEmoji", setOf(
        ResourceItem(setOf(), "${MD}font/NotoEmoji.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("NotoEmoji", Res.font.NotoEmoji)
}
